import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { captureReferralCodeFromURL } from '../utils/referral';

/**
 * Component to handle referral code capture from URL parameters
 * This component should be placed inside the Router context
 */
const ReferralHandler = () => {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const capturedCode = captureReferralCodeFromURL(searchParams);

    if (capturedCode) {
      console.log('Referral code captured:', capturedCode);
      // Keep the URL with referral parameter - don't clean it up
    }
  }, [location]);

  return <Outlet />;
};

export default ReferralHandler;
